// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__X_5MZ","wrapperText":"styles_wrapperText__WTr2z","content":"styles_content__2Yff4"};